module.exports = "/_next/static/images/springfield-mo-ea2dbc76f7ae7237b373a5a357b2eb6f.jpg";